var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200px",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-ad-placements",
                              title: _vm.getTitle
                                ? `${_vm.getTitle} рекламное место`
                                : `Создать рекламное место`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "PageContent",
                            { attrs: { height: "85" } },
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Название рекламного места *"
                                            ),
                                          ]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "title",
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.validationErrors.title,
                                            },
                                            model: {
                                              value: _vm.fields.title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.title",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("ID *")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "slotId",
                                              outlined: "",
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                              "error-messages":
                                                _vm.validationErrors.slotId,
                                            },
                                            model: {
                                              value: _vm.fields.slotId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "slotId",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.slotId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Ширина *")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "width",
                                              outlined: "",
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                              "error-messages":
                                                _vm.validationErrors.width,
                                            },
                                            model: {
                                              value: _vm.fields.width,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "width",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "fields.width",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Высота *")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "height",
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.validationErrors.height,
                                            },
                                            model: {
                                              value: _vm.fields.height,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "height",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression: "fields.height",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Iframe URL *")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "url",
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                              "error-messages":
                                                _vm.validationErrors.url,
                                            },
                                            model: {
                                              value: _vm.fields.url,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.fields, "url", $$v)
                                              },
                                              expression: "fields.url",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("span", [_vm._v("Комментарий")]),
                                          _c("v-text-field", {
                                            attrs: {
                                              outlined: "",
                                              disabled: _vm.disabled,
                                              loading: _vm.loading,
                                            },
                                            model: {
                                              value: _vm.fields.note,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fields,
                                                  "note",
                                                  $$v
                                                )
                                              },
                                              expression: "fields.note",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      "is-new": _vm.isNew,
                      isLocales: false,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "is-loading": _vm.loading,
                      "entity-id": _vm.data.id,
                      "entity-type": "adPlacement",
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-ad-placement")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-ad-placements" })
                      },
                      submit: _vm.submit,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }